import { SECTION_TYPES } from "@/lib/constants/sections";
import { NotebookPen } from "lucide-react";

const freeFormSection = {
  type: SECTION_TYPES.FREE_FORM,
  content: {
    header: "Free form content",
    freeform: "You can write anything here, and it will be displayed.",
  },
  meta: {
    displayName: "Free Form",
    displayDescription: "Add free form content to your page.",
    displayIcon: NotebookPen,
  },
};

export default freeFormSection;
